/* unplugin-vue-components disabled */import { render } from "./DiagramChapterEditor.vue?vue&type=template&id=7af81f92&scoped=true&ts=true"
import script from "./DiagramChapterEditor.vue?vue&type=script&lang=ts"
export * from "./DiagramChapterEditor.vue?vue&type=script&lang=ts"

import "./DiagramChapterEditor.vue?vue&type=style&index=0&id=7af81f92&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af81f92"]])

export default __exports__